<template>
  <a-menu
    v-model:openKeys="openKeys"
    v-model:selectedKeys="selectedKeys"
    mode="inline"
    class="abc"
    :style="{ height: '100%', borderRight: 0 }"
  >
    <!-- 循环输出菜单项目, 这里一定不要为component绑定循环的key，绑定后会导致菜单高亮失效 -->
    <!-- eslint-disable vue/valid-v-for -->
    <component :is="item" v-for="(item) in renderMenuItems" />
  </a-menu>

</template>

<script setup>
import { useStore } from 'vuex'
import { computed, ref, watch, h, resolveComponent, defineProps } from 'vue'
import { useRouter } from 'vue-router'
const store = useStore()
import { MenuItem, SubMenu } from 'ant-design-vue'
const router = useRouter()
import * as Icons from '@ant-design/icons-vue'
import { camelCase, upperFirst } from 'lodash'

const props = defineProps({
  menuList: {
    require: false,
    type: [Boolean, Array],
    default: () => false
  }
})

const visibleMenuList = computed(() => {
  if (props.menuList) {
    return props.menuList
  } else {
    return store.getters['user/visibleMenuList']
  }
})
// eslint-disable-next-line no-unused-vars
const userInfoReady = computed(() => {
  return store.getters['user/basicInfo'].id
})
const iconExists = (iconName) => {
  return Icons[iconName] !== undefined
}

const getIconComponent = (icon) => {
  // 根据icon值返回对应的图标组件
  if (iconExists(upperFirst(camelCase(`${icon}-outlined`)))) {
    return upperFirst(camelCase(`${icon}-outlined`))
  }
  return `AppstoreOutlined`
}

const handleClick = function (item) {
  const fullPath = item.path
  const urlObj = new URL(fullPath, window.location.origin) // 使用 window.location.origin 作为基地址
  const params = new URLSearchParams(urlObj.search)
  const queryParams = {}
  params.forEach((value, key) => {
    queryParams[key] = value
  })

  // 检查 target 参数的值是否为 'blank'
  if (queryParams.target === 'blank') {
    // 在新窗口中打开新的 URL
    window.open(fullPath, '_blank')
  } else {
    // 正常路由跳转
    router.push({
      path: urlObj.pathname,
      query: {
        ...queryParams
      }
    })
  }
}

/**
 *  路由菜单的render函数
 */

const renderMenuItem = function (item) {
  if (!item.children || item.children.length <= 0) {
    return h(MenuItem,
      {
        'onClick': () => handleClick(item),
        'key': item.path
      },
      { default: () => [
        h(resolveComponent(getIconComponent(item.icon))),
        h('span', { title: item.name }, item.name)
      ] })
  } else {
    return h(SubMenu,
      {
        'key': item.path
      },
      {
        title: () => [
          h(resolveComponent(getIconComponent(item.icon))),
          h('span', { title: item.name }, item.name)
        ],
        default: () => item.children.map(subItem => renderMenuItem(subItem))
      }
    )
  }
}

const renderMenuItems = computed(function () {
  return visibleMenuList.value.map(item => renderMenuItem(item))
})

/**
 *  高亮路由菜单逻辑
 */

const activeRouteMatched = computed(() => {
  const route = router.currentRoute.value
  return route.matched.map(item => item.path)
})

const selectedKeys = ref([])
const openKeys = ref([])
const findParents = function findParents(treeArray, key) {
  function dfs(node, target, path) {
    if (!node) {
      return false
    }

    path.push(node.path)

    if (node.path === target) {
      return true
    }

    for (const child of node.children || []) {
      if (dfs(child, target, path)) {
        return true
      }
    }

    path.pop()
    return false
  }

  let path = []
  for (const tree of treeArray) {
    if (dfs(tree, key, path)) {
      return path.slice(0, -1) // Remove the key itself from the path
    }
    path = [] // Reset path for the next tree
  }

  return [] // Key not found in any tree
}
watch(activeRouteMatched, () => {
  selectedKeys.value = [router.currentRoute.value.path]
  // openKeys.value = [].concat(activeRouteMatched.value)

  // 通过当前路由，获取他所处菜单中的parent
  const openedKeys = findParents(visibleMenuList.value, router.currentRoute.value.path)
  if (openedKeys && openedKeys.length > 0) {
    openKeys.value = openedKeys
  }
}, {

  immediate: true
})

</script>
<style>
.ant-layout .ant-layout-sider-children{
  height:auto !important
}
</style>
